import { s } from './constants/sizes'
import { colors } from './config/colors'
import { alpha } from './constants/alpha'
import { globals } from './config/globals'

export const grid = (n) => (n / 12) * 100 + '%'

export const sContainer = {
  maxWidth: 1024,
  margin: '0 auto',
  padding: '2rem 1rem',
  paddingTop: `calc(96px + 4rem)`,
  marginBottom: '6rem',
  [s.sm_down]: {
    paddingTop: `calc(96px + 2rem)`,
    marginBottom: '4rem',
  },
  [s.md]: {
    paddingLeft: '4rem',
    paddingRight: '4rem',
  },
}

export const sContainerPadding = {
  marginBottom: 0,
  paddingBottom: '6rem',
  [s.sm_down]: {
    marginBottom: 0,
    paddingBottom: '4rem',
  },
}

export const sSection = {
  width: '100vw',
  maxWidth: 1500,
  margin: '6rem auto 0rem',
  padding: '1rem 1rem 4rem',
  [s.sm_down]: {
    margin: '4rem auto 0rem',
    padding: '1rem 1rem 2rem',
  },
  display: 'flex',
  flexWrap: 'wrap',
}

export const sCenteredSpaced = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '4rem auto 0',
  padding: '1rem 1rem 4rem',
  [s.sm_down]: {
    margin: '2rem auto 0',
  },
}

export const sPadding = {
  [s.sm_down]: {
    padding: '0 2rem',
  },
  [s.md]: {
    padding: '0 4rem',
  },
}

export const sMarginTop = {
  marginBottom: '4rem',
  [s.sm_down]: {
    marginBottom: '2rem',
  },
}

export const sTitle = {
  margin: '0 auto',
  width: '100%',
  maxWidth: 'inherit',
  marginBottom: '3rem',
  textAlign: 'left',
  fontSize: '2.5rem',
  [s.sm]: {
    fontSize: '3rem',
  },
  [s.ss]: {
    fontSize: '2.25rem',
  },
}

export const sSubtitle = {
  fontSize: '0.785rem',
  [s.sm_down]: {
    fontSize: '0.75rem',
  },
  fontWeight: 700,
  textTransform: 'uppercase',
  opacity: 0.3,
}

export const sDesc = {
  fontSize: '1rem',
  lineHeight: '1.618em',
  opacity: 0.6,
}

export const sImage = {
  maxWidth: 'inherit',
  paddingTop: '56.25%',
  position: 'relative',
  borderRadius: '2rem',
  backgroundColor: colors.greyDarker,
  [s.sm_down]: {
    borderRadius: '1rem',
    paddingTop: '56.25%',
  },
}

export const sGatsbyImage = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  borderRadius: 'inherit',
  transform: 'translate3d(0,0,0)',

  img: {
    borderRadius: 'inherit',
    transform: 'translate3d(0,0,0)',
  },
}

export const sHtml = {
  maxWidth: globals.maxWidth,
  // overflow: 'hidden',
  [s.sm_down]: {
    marginTop: globals.spacing.outside.mobile,
    padding: globals.spacing.inside.mobile + 'px 0',
  },
  [s.md]: {
    margin: '0 auto',
    padding: globals.spacing.inside.desktop + 'px 0',
  },

  p: {
    fontSize: '1rem',
    lineHeight: '2em',
    margin: '0 0 2rem',

    [s.xs]: {
      fontSize: '1rem',
    },
    position: 'relative',
  },
  h2: {
    fontSize: '1.5rem',
    padding: '2.5rem 0 1.5rem',
    margin: 0,
  },
  h3: {
    fontSize: '1.25rem',
    padding: '2rem 0 ',
  },
  h4: {
    fontSize: '1.125rem',
    padding: '1.5rem 0',
  },
  blockquote: {
    marginInlineStart: 0,
    marginInlineEnd: 0,
  },
  hr: {
    marginBottom: '2rem',
    marginTop: '2rem',
    opacity: 0.3,
  },
  iframe: {
    borderRadius: '1.5rem',
    width: '100%',
    height: 'calc(9 * (100% - 4rem) / 16)',
    aspectRatio: '16/ 9',
    marginBottom: '2rem',
    [s.lg]: {
      width: '100%',
      height: 'calc(calc(869px * 9) / 16)',
    },
    [s.sm_down]: {
      borderRadius: '1rem',
    },
  },

  '* > img': {
    display: 'block',
    width: 'auto',
    height: 'auto',
    margin: '2rem auto',
    borderRadius: '1.5rem',

    [s.sm_down]: {
      borderRadius: '1rem',
      objectFit: 'cover',
      width: '100%',
      // height: 'calc(9 * (100vw - 4rem) / 16)',
      maxWidth: '100%',
      // maxHeight: 'calc(9 * (100vw - 4rem) / 16)',
      margin: 0,
    },
    [s.md]: {
      width: '100%',
      // width: '100%',
      // aspectRatio: '16/ 9',
      objectFit: 'cover',
      maxHeight: 832,
    },
    // [s.lg]: {
    //   '@media (max-aspect-ratio: 1/1)': {
    //     width: '50% !important',
    //     maxWidth: '50% !important',
    //   },
    // },
  },
  table: {
    maxWidth: '100vw',
    fontSize: '0.75rem',
    textAlign: 'left',
    borderCollapse: 'collapse',
    width: '100%',
    margin: '0 0 30px',
    boxSizing: 'border-box',
    border: '1px solid rgba(167, 167, 167, .2) !important',
    overflow: 'scroll',
  },
  td: {
    padding: '30px 5px',
    border: '1px solid rgba(167, 167, 167, .2) !important',
  },
  ul: {
    paddingBottom: '1rem',
  },
  li: {
    marginBottom: '1rem',
    lineHeight: '1.68em',
    color: colors.text.concat(alpha[60]),
    marginLeft: '2rem',
  },
  a: {
    textDecoration: 'underline',
    fontWeight: 'bold',
  },
  '.button-wrapper': {
    display: 'flex',
    justifyContent: 'center',
  },
  'a.accent-button': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: '2rem',
    textDecoration: 'none',
    transition: 'all 0.2s ease-out',
    width: 'max-content',
    fontSize: '0.875rem', // was 1rem
    letterSpacing: '0rem',
    background: `linear-gradient(to bottom right, ${colors.brandDark}, ${colors.brandLight})`,
    padding: '1rem 3rem',
    boxShadow: `0px 0px 32px #b6c905`,
    textTransform: 'uppercase',
    fontWeight: 700,
    borderRadius: '2rem',
    color: colors.white,
    [s.xs]: {
      width: '100%',
    },
    '&:focus': {
      filter: 'brightness(75%) contract(2)',
      transform: 'scale(1.1)',
    },

    '&:hover': {
      filter: 'brightness(125%)',
      boxShadow: `0px 0px 16px #b6c905`,
    },
  },
  'p em': {
    fontSize: '0.75rem',
    opacity: 0.6,
    paddingTop: '2rem',
  },
}

export const sHtmlList = {
  ...sHtml,
  li: {
    marginLeft: '1rem',
    fontSize: '0.875rem',
    marginBottom: '0.5rem',
  },
  overflow: 'visible',
  '.contentfulButtonWrapper': {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2rem',
    a: {
      transition: 'all 0.2s ease-out',
      width: 'max-content',
      fontSize: '0.875rem', // was 1rem
      letterSpacing: '0rem',
      // background: `linear-gradient(to bottom right, ${colors.brandDark}, ${colors.brandLight})`,
      background: `linear-gradient(45deg, ${colors.brandDark} 0%, ${colors.brand} 50%, ${colors.brandLight} 100%);`,
      padding: '1rem 3rem',
      boxShadow: `0px 0px 32px #b6c905`,
      textTransform: 'uppercase',
      fontWeight: 700,
      borderRadius: '2rem',
      color: colors.white,
      textDecoration: 'none',
      '&:focus': {
        filter: 'brightness(75%) contract(2)',
        transform: 'scale(1.1)',
      },

      '&:hover': {
        filter: 'brightness(105%)',
        boxShadow: `0px 0px 16px #b6c905`,
      },
    },
  },
}

export const sHtmlTemplateBody = {
  ...sHtml,
  ul: {
    margin: '2rem 0 3rem',
    [s.xs]: {
      margin: '1rem 0 2rem',
    },
  },
  li: {
    marginLeft: '4rem',
    fontSize: '0.875rem',
    marginBottom: '1rem',
    opacity: 0.6,
    [s.xs]: {
      marginLeft: '2rem',
      fontSize: '0.75rem',
      marginBottom: '1rem',
    },
  },
}

export const sButtons = {
  display: 'flex',
  justifyContent: 'space-between',
  [s.xs]: {
    flexDirection: 'column',
  },
}

export const sDecoPath = {
  display: 'flex',
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 0,

  svg: {
    position: 'relative',
  },
  'svg path': {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
  },
  [s.sm_down]: {
    top: 0,
    svg: {
      maxWidth: '100vw',
    },
  },
  [s.xs]: {
    top: '-5rem',
    svg: {
      maxWidth: '120vw',
    },
  },
}

export const sTextGradient = {
  background: `linear-gradient(to right, ${colors.white.concat(
    alpha[100]
  )}, ${colors.white.concat(alpha[16])})`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}

export const sTextGradientBlack = {
  background: `linear-gradient(to right, ${colors.text.concat(
    alpha[100]
  )}, ${colors.text.concat(alpha[60])})`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}

export const sDesktop = {
  '@media screen and (max-width: 1399px)': { display: 'none' },
}

export const sMobile = {
  '@media screen and (min-width: 1400px)': { display: 'none' },
}

export const sSectionTitle = [
  sSection,
  sPadding,
  {
    marginBottom: '2rem',
    [s.sm_down]: {
      marginBottom: '2rem',
    },
  },
]

export const sSectionContainer = {
  width: '100vw',
  maxWidth: 1500,
  margin: '4rem auto 2rem',
  padding: '0 2rem',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  [s.md]: {
    padding: '0 4rem',
    margin: '8rem auto 2rem',
  },
}

export const sInput = {
  fontSize: '1rem',
  letterSpacing: '-0.05em',
  fontFamily: 'Open Sans',
  outline: 'none',
  border: 'none',
  width: '100%',
  appearance: 'none',
  backgroundColor: colors.greyDark.concat(alpha[8]),
  transition: 'color 0.25s linear, background-color 0.25s linear',
  borderRadius: '1rem',
  color: colors.text,
  padding: '1rem 2rem',
  fontWeight: 700,
  [s.xs]: {
    maxHeight: 50,
    minHeight: 50,
  },
  [s.sm_down]: {
    marginBottom: '1.25rem',
    fontSize: '0.875rem',
  },
  [s.md]: {
    marginBottom: '1.25rem',
  },
  '&:focus, &:hover': {
    color: `${colors.greyDark} !important`,
  },
  '&:hover': {
    backgroundColor: colors.greyDark.concat(alpha[4]),
  },
  '&:focus': {
    backgroundColor: colors.greyDark.concat(alpha[16]),
  },
  '::placeholder': {
    color: 'currentColor',
    opacity: 0.5,
  },
}

export const sInputError = {
  backgroundColor: colors.red.concat(alpha[8]),
  color: colors.red,
  '::placeholder': {
    color: 'currentColor',
  },
}

export const sFormTextBottom = {
  fontSize: '0.675rem',
  opacity: 0.5,
  marginBottom: '1rem',
  p: {
    marginBottom: '.25rem',
  },
  ul: {
    marginLeft: '20px',
    marginBottom: '.25rem',
  },
  ol: {
    marginLeft: '20px',
    marginBottom: '.25rem',
  },
}

export const sTextArea = {
  width: '100%',
  maxWidth: '100%',
  minWidth: '100%',
  minHeight: 54,
  [s.xs]: {
    maxHeight: '100%',
  },
}

export { colors, s, alpha, globals }

// export default { colors, s, alpha, globals }
